import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "spectrum-uxp-widgets"
    }}>{`Spectrum UXP Widgets`}</h1>
    <p>{`Spectrum UXP is designed to mimic HTML5 Web Components. This allows UXP to expose a consistent yet custom user interface without requiring a specific framework (such as React or Vue) while still encapsulating the implementation details.`}</p>
    <p>{`In order to get started, you can just start using the Spectrum UXP controls as you would any other HTML tag. You don't need to include any special libraries – they are immediately available in the global context.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-button>Get started!</sp-button>
`}</code></pre>
    <p>{`It's that easy!`}</p>
    <h2 {...{
      "id": "pages-in-this-section"
    }}>{`Pages in this section`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Typography/index.md"
        }}>{`Typography`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "User%20Interface/index.md"
        }}>{`User Interface`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      